var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgMind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9972 4.53953C11.5992 3.3721 10.3701 2.92679 9.30494 3.07121C8.26315 3.31192 7.63105 4.16643 7.59593 5.05705C5.55917 5.09316 4.64614 6.99475 5.02072 8.93094C3.88528 9.49661 3.38194 10.6279 3.42876 11.8796C3.47559 13.1794 4.1311 14.4672 5.11436 15.0449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88408 14.9646C4.17287 16.9037 5.73016 18.8443 8.14579 18.7482C8.25615 19.9069 9.29843 20.6282 10.2671 20.6164C11.4811 20.6164 12.4253 19.8242 12.4253 18.7482V4.75936"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4375 4.52419C12.8356 3.36874 14.0066 2.928 15.0722 3.07094C16.208 3.32109 16.852 4.21448 16.852 5.02448C18.8778 5.11978 19.7677 7.0495 19.1354 8.47892C20.4469 9.02686 20.9972 10.2419 20.9972 11.6117C20.9972 12.922 20.4117 14.149 19.475 14.5301C20.3415 16.579 18.8661 18.7961 16.5827 18.77C16.4422 19.9255 15.3532 20.6163 14.4281 20.6163C13.2689 20.6163 12.4258 19.7825 12.4258 18.6985"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56641 7.33057C9.24909 7.62112 9.78385 8.27488 9.85212 9.04485"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42578 12.2294C7.6331 11.7246 9.05993 12.3097 9.42578 13.3306"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8521 7.33057C15.1701 7.62112 14.6558 8.27488 14.5664 9.04485"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9961 12.2148C16.7985 11.728 15.4437 12.3453 14.9961 13.3306"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2829 15.9023C16.1982 16.3547 15.8402 16.7833 15.454 17.0928L15.4258 17.6166"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99777 17.6167C8.86682 18.1751 8.52158 18.7076 8.14062 18.9024"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMind);
export default __webpack_public_path__ + "static/media/mind.25da224a80f4612b9f4b69f97428a6ac.svg";
export { ForwardRef as ReactComponent };